import { dateUtils } from '@/utils'
import { type RecurrenceSettingsState } from '../../../types'

export function parseDateFromCurrentState(state: RecurrenceSettingsState): Date {
  const {
    referenceDate,
    value: {
      recurrencePeriod: { date },
    },
  } = state

  if (date) {
    return dateUtils.parseDate(date)
  }

  return referenceDate
}
